<template>
  <el-container class="indexhome">
    <el-header>
      <img
        class="logo"
        src="../assets/logo.svg">
      <!-- <p>{{$t('global.parentTitle')}}</p> -->
      <p>&nbsp;</p>
    </el-header>
    <el-main>
      <!-- 添加小孩 -->
      <div class="rules_form">
        <p @click="back()"><i class="icon el-icon-arrow-left" style="font-weight: bold;"></i>{{$t('global.back')}}</p>
        <el-form  ref="childForm" label-width="100px" class="demo-childForm">
          <!-- 小孩列表 -->
          <div class="addForm">
          <h3>{{$t('myChild.whoAttend')}}</h3>
          <p v-if="studentData.length==0">{{$t('myChild.minimumChild')}}</p>
          <div class="childList">
            <div v-for="(item,i) in studentData" :key="i"  @click="chooseAvatar(item)">
              <p><img :src="item.avatar"/><img class="borderAvatar" v-if="item.selected" src="../assets/Ellipse108.svg" /></p>
              <!-- <p><img :src="item.avatar"/><img class="borderAvatar" v-if="item.selected" src="../assets/Ellipse141.png" /></p> -->
              <p :class="item.selected?'selected':''"><span :title="item.nickname">{{item.nickname}}</span>
                <span>(Age {{item.age}})</span></p>
            </div>
            <div v-if="studentData.length<1">
              <!-- <el-button class="addChildAvatar" type="text" autocomplete="off" @click="addChild"></el-button> -->
              <p><img @click="addChild" src="../assets/Ellipse141.png"/></p>
              <span class="font_18_reg" @click="addChild">{{$t('myChild.addChild')}}</span>
            </div>
          </div>
          </div>
          <p class="huo" @click="editStud">{{$t('myChild.editChild')}}</p>
          <el-button style="background: #FF6E17;border-color: #FF6E17" class='disabled' type="primary" @click="toNextIndex()">{{$t('global.next')}}</el-button>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '../store';
export default {
  name: 'addChild',
  data () {
    return {
      studentData: []
    }
  },
  created () {
    this.$http.get('/api/students').then((res) => {
      if (res.data.code == 200) {
        console.log(res)
        this.studentData = res.data.data
      } else {
        this.$message({
          message: res.data.msg,
          type: 'warning'
        })
      }
    }).catch((error) => {
      console.log(error) // 请求失败返回的数据
    })
  },
  methods: {
    back () {
      this.$router.push({ path: '/email' })
    },
    addChild () {
      this.$router.push({ path: '/add?add=1' })
    },
    chooseAvatar (avatarItem) {
      this.studentData.map((item) => {
        if (item.student_sn == avatarItem.student_sn) {
          item.selected = true
        } else {
          item.selected = false
        }
      })
      this.$forceUpdate()
    },
    editStud () {
      this.studentData.map((item) => {
        if (item.selected) {
          this.selectedData = item
        }
      })
      if (!this.selectedData) {
        this.$message({
          message: this.$t('errorprompt.selectChild'),
          type: 'warning'
        })
        return false
      }
      this.$router.push({ path: '/add?edit=' + encodeURIComponent(JSON.stringify(this.selectedData)) })
    },
    toNextIndex () {
      this.$http.post('/api/setUserStatus').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          setStore(keys.userInfo, res.data.data)
          this.$router.push({ path: '/home/children/AttendClassNow' })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 1200px;
    height:auto!important;
    margin: 0 auto;
  }
  .el-header{
      width: 1200px;
      height:auto!important;
      padding: 20px 0 0;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        width: 227px;
        margin-top:5px;
        text-align: center;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    h3{
      font-size: 24px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #697386;
      margin-bottom:14px;
    }
    p{
      font-size: 18px;
      font-family: Sofia Pro-Regular;
      color: #424347;
      margin-bottom:29px;
    }
    .rules_form{
        width: 50%;
        margin: 0 auto;
        .el-form {
            // width: 100%;
            // border: 1px solid red;
            height:100%;
            padding:20px;
            display: flex;
            flex-direction: column;
            background: #fff;
            // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
            border-radius: 10px;
            .childList{
              width:100%;
              margin-bottom:40px;
              display: flex;
              flex-wrap: wrap;
              /deep/ .el-form-item{

                &:nth-child(6n){
                  margin-right: 0;
                }
                .el-form-item__content{
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  margin:0!important;
                  p{
                    font-size: 18px;
                    color: #FF6440;
                    font-family: Sofia Pro-Regular;
                  }
                }
              }
              // .addChildAvatar{
              //   width:80px;
              //   height:80px;
              //   border:none;
              //   background: inherit;
              //   background-size: 80px 80px;
              //   background-image: url('../assets/add-child-icon.svg');
              // }
              >div{
                margin-right: 28px;
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-direction: column;
                &:nth-child(6n){
                  margin-right: 0;
                }
                >p{
                  font-size: 14px;
                  color: #FF6440;
                  font-family: Sofia Pro-Regular;
                  margin-top: 10px;
                  margin-bottom: 0;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  position: relative;
                  .borderAvatar{
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    margin: 0;
                    color: red;
                  }
                  span{
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #353643;
                    margin-bottom:5px;
                  }
                  >.selected span{
                    color: #FF6440;
                  }
                }
                >span{
                  font-weight: bold;
                  font-size: 18px;
                  color: #000000;
                  font-family: Sofia Pro-Regular;
                  margin-top: 25px;
                  margin-bottom: 0;
                }
                img{
                  width:80px;
                  height:80px;
                }
              }
            }
            .addForm{
                  width: 400px;
                  // border: 1px solid red;
                  margin: 40px auto 0 auto;
              .addFormList{
                border: 1px dashed #FF6440;
              }
            }

            .huo {
              font-size: 16px;
              font-family: Sofia Pro-Bold;
              font-weight: 700;
              text-decoration: underline;
              text-align: LEFT;
              color: #ff6440;
              cursor: pointer;
              display: contents;
              margin: 0 auto;
              display: block;
              margin-top:120px;
            }
            button{
              width: 310px;
              height: 50px;
              background: #4B69FE;
              border-radius: 50px;
              border: 1px solid #4B69FE;
              margin-bottom: 15px;
              color: #fff;
              font-size: 16px;
              font-family: Sofia Pro-Bold;
                  margin: 10px auto 56px auto;
              // box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            }
            .borderBtn{
                width:auto;
                height: 40px;
                background: #ffffff;
                border: 2px solid #ff6440;
                border-radius: 7px;
                font-size: 14px;
                font-family: Sofia Pro-Bold;
                font-weight: 700;
                color: #ff6440;
                margin: 0 20px;
                &:hover{
                  background: #ffffff;
                  border: 2px solid #ff6440;
                  font-size: 14px;
                  font-family: Sofia Pro-Bold;
                  font-weight: 700;
                  color: #ff6440;
                }
            }
            input{
              width:345px;
              height: 50px;
              border:none;
              background: none;
              font-size: 18px;
              color: #353643;
              font-family: Sofia Pro-Regular;
              letter-spacing: 0px;
            }
            input:focus {
              outline: none;
            }
          }
        }
  }

</style>



// WEBPACK FOOTER //
// src/components/addChild.vue